import React from 'react';
import Alert from '@amzn/awsui-components-core/alert';
import Button from '@amzn/awsui-components-core/button';
import Spinner from '@amzn/awsui-components-core/spinner';
import type { ReportParameter } from 'src/components/star-grid/reportDefinition.types';
import type { StarGridText } from 'src/components/star-grid/hooks/useStarGridText';
import { useReportParameter } from 'src/components/star-grid/hooks/useReportParameter';
import { useReportHierarchySelection } from 'src/components/star-grid/hooks/useReportHierarchySelection';
import MemberSubsetModal from 'src/components/star-grid/components/subset-editor/MemberSubsetModal';
interface Props {
  readonly parameter: ReportParameter;
  readonly values: readonly string[];
  readonly text: StarGridText;
  readonly onChange: (key: string, values: readonly string[]) => void;
  readonly onDismiss: () => void;
}
export const StudioParameterMembers: React.FC<Props> = ({ parameter, values, text, onChange, onDismiss }) => {
  const choices = useReportParameter(parameter, values);
  const selection = useReportHierarchySelection(parameter, values, choices.tree, onChange);
  return (
    <>
      {choices.loading && <Spinner />}
      {choices.error && (
        <Alert type="error" action={<Button onClick={choices.reload}>{text('retry')}</Button>}>
          {choices.error.message}
        </Alert>
      )}
      {choices.tree && (
        <MemberSubsetModal
          embedded
          visible
          hierarchyId={choices.tree.hierarchy_id}
          hierarchyTree={choices.tree}
          dimensionLabel={parameter.label}
          multiple={parameter.multiple}
          requireSelection={parameter.required && !parameter.multiple}
          initialChecked={selection.initialChecked}
          onConfirm={selection.confirm}
          onDismiss={onDismiss}
          testId={`studio-parameter-members-${parameter.key}`}
        />
      )}
    </>
  );
};
